module.exports = __webpack_public_path__ + "0da6b58c22b0d7ca538d792aba437d1b.pdf";